import { Editor } from "@tiptap/core";

export class ImageManager {
  #editor: Editor;

  constructor(editor: Editor) {
    this.#editor = editor;
  }

  /**
   * Gets state for the selected image node
   */
  getNodeState() {
    if (!this.#editor.isActive("image")) return null;

    const attrs = this.#editor.getAttributes("image");

    return {
      src: attrs.src,
      alt: attrs.alt,
      title: attrs.title,
      width: attrs.width || "100%",
      height: attrs.height || "auto",
      align: attrs.align || "center",
      wrap: attrs.wrap || false,
      margin: attrs.margin || "0",
    };
  }

  /**
   * Updates image alignment
   */
  setAlignment(align: "left" | "center" | "right" | "full") {
    this.#editor.chain().focus().updateAttributes("image", { align }).run();
  }

  /**
   * Updates image width
   */
  setWidth(width: string) {
    this.#editor.chain().focus().updateAttributes("image", { width }).run();
  }

  /**
   * Updates image margin
   */
  setMargin(margin: string) {
    this.#editor.chain().focus().updateAttributes("image", { margin }).run();
  }

  /**
   * Toggles text wrapping
   */
  setWrap(wrap: boolean) {
    const value = !!wrap;
    const currentAlign = this.#editor.getAttributes("image").align;
    const chain = this.#editor.chain().focus();

    if (value && (!currentAlign || currentAlign === "center")) {
      // Cannot wrap if centered, default to left
      chain.updateAttributes("image", { align: "left" });
    }

    chain.updateAttributes("image", { wrap: value }).run();
  }

  /**
   * Deletes the selected image
   */
  deleteImage() {
    this.#editor.chain().focus().deleteSelection().run();
  }
}
